import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ImageItem } from '@app/_models/images-manager/images-management.model';
import { interval, Observable, startWith, Subject, switchMap, timer } from 'rxjs';

@Component({
    selector: 'images-slider',
    templateUrl: 'images-slider.component.html',
    styleUrls: ['images-slider.component.scss'],
})
export class ImagesSliderComponent implements OnInit, OnDestroy {
    @Input() slides: ImageItem[] = [];

    @Input() currentIndex: number = 0;
    timeoutId?: number;

    ngOnInit(): void {
        this.resetTimer();
    }

    ngOnDestroy() {
        window.clearTimeout(this.timeoutId);
    }

    resetTimer() {
        if (this.timeoutId) {
            window.clearTimeout(this.timeoutId);
        }
        this.timeoutId = window.setTimeout(() => this.goToNext(), 5000);
    }

    goToPrevious(): void {
        const isFirstSlide = this.currentIndex === 0;
        const newIndex = isFirstSlide ? this.slides.length - 1 : this.currentIndex - 1;

        this.resetTimer();
        this.currentIndex = newIndex;
    }

    goToNext(): void {
        const isLastSlide = this.currentIndex === this.slides.length - 1;
        const newIndex = isLastSlide ? 0 : this.currentIndex + 1;

        this.resetTimer();
        this.currentIndex = newIndex;
    }

    goToSlide(slideIndex: number): void {
        this.resetTimer();
        this.currentIndex = slideIndex;
    }

    getCurrentSlideUrl() {
        return `url('${this.slides[this.currentIndex].url}')`;
    }
}
